import { select } from 'redux-most';
import { switchMap, fromFuture } from 'most-adjunct';
import * as mostc from '../../../crosscutting/mostc';
import * as most from 'most';
import * as r from 'ramda';
import * as signals from '../../signals';
import * as messages from '../../../domain/messages';

export default function createOptInEpic(
  optInRepo,
  cleanseRepo,
  emitEvent,
) {
  return (actions, store) => r.pipe(
    select(signals.OPT_IN),
    switchMap((action) => {
      const {
        categories,
      } = action.payload;

      const state = store.getState();
      const categoryKeyIdMap = state.config.categories;
      const preserve = state.config.cookiesToPreserve;

      const categorySettings = r.mergeDeepRight(
        categoryKeyIdMap,
        r.map((v) => ({ enabled: v }))(categories),
      );

      const cleansing = cleanseRepo(preserve);

      const optingIn = cleansing
        .chain(() => {
          return optInRepo(categorySettings, 365)
            .map(r.tap(() => {
              emitEvent('@upm/opted-in', {
                categories: categorySettings,
              });
            }))
            .map(r.tap(() => {
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }))
            .map(() => messages.optedIn());
        });

      return most.merge(
        most.of(messages.optInRequested()),
        fromFuture(optingIn),
      );
    }),
  )(actions);
}



// WEBPACK FOOTER //
// ./src/application/epics/privacy/optIn.js